import React, { PropsWithChildren } from 'react';
import { BaseCard } from 'src/components/common';
import { makeStyles } from '@material-ui/core/styles';
import { getScrollbarStyles } from 'src/materialConfig/commonStyles';

const useStyles = makeStyles(() => ({
  card: {
    padding: '12px 0',
  },
  list: {
    maxWidth: '280px',
    maxHeight: '250px',
    overflowY: 'auto',
    ...getScrollbarStyles(),
  },
  notifications: {
    display: 'grid',
    gridGap: '7px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  noData: {
    padding: '5px 15px',
  },
}));

// Inspired by https://wanago.io/2020/03/09/functional-react-components-with-generic-props-in-typescript/

interface IProps<T extends { id: number }> {
  list: T[];
  renderedItem: (listItem: T) => React.ReactElement;
  loading: boolean;
  bottomInfo?: React.ReactNode;
}

export const NotificationsCard = <TListItem extends { id: number }>(
  props: PropsWithChildren<IProps<TListItem>>,
) => {
  const { loading, list, renderedItem, bottomInfo } = props;
  const classes = useStyles();

  const notificationsDom = (
    <div className={classes.notifications}>
      {list.map((item) => renderedItem(item))}
    </div>
  );

  return (
    <BaseCard className={classes.card} loading={loading}>
      <div className={classes.list}>
        {list.length ? (
          notificationsDom
        ) : (
          <div className={classes.noData}>No data</div>
        )}
      </div>
      {bottomInfo}
    </BaseCard>
  );
};
